<template>
  <v-menu offset-y :max-width="menuWidth" content-class="asc-menu-button" left>
    <template #activator="{ on, attrs }">
      <asc-accent-button
        :button-text="buttonText"
        :bind="attrs"
        :on="on"
        :icon="icon"
        icon-position="right"
        :disabled="isDisabled"
        :secondary="secondary"
      ></asc-accent-button>
    </template>
    <v-list class="list">
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        class="list-item"
        @click="handleClick(item)"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import AscAccentButton from '@/components/atoms/AscAccentButton'

export default {
  name: 'AscMenuContainer',

  components: { AscAccentButton },

  props: {
    menuWidth: {
      type: Number,
      default: 250,
    },
    buttonText: {
      type: String,
      default: 'Export',
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'expand_more',
    },
    items: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onSelection: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    isDisabled() {
      return this.disabled || this.items.length === 0
    },
  },

  methods: {
    handleClick(item) {
      if (this.onSelection) {
        this.onSelection(item)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-menu-button {
  .list {
    padding: 0;

    .list-item {
      min-height: 34px;
      padding: 0;
      cursor: pointer;

      .v-list-item__title {
        color: $primary-black;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 18px;
        padding: 7px 10px;
      }

      &:hover {
        background-color: $gray-100;
      }
    }
  }
}
</style>
